/* 🤖 this file was generated by svg-to-ts */
export const svgRoundBarGrey: {
    name: "round-bar-grey";
    data: string;
} = {
    name: "round-bar-grey",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__round-bar-grey" class="ng__path-round-bar-grey" viewBox="0 0 330 10"><g fill="none" fill-rule="evenodd"><g id="ng__M-New-filtre-07C" transform="translate(-29 -515)"><g id="ng__Group-3" transform="translate(21 491)"><g id="ng__Group-4" transform="translate(8 24)"><path id="ng__Line-Copy-6" stroke="#DDD3C6" stroke-linecap="square" d="M8.5 6 330 5.5"/><circle id="ng__Oval" cx="5" cy="5" r="5" fill="#D0C2B0"/></g></g></g></g></symbol></svg>`,
};
